import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.667 9.999 2.5 2.5 4.166-5m-10 6.5v-8c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728.357-.182.824-.182 1.757-.182h8c.934 0 1.4 0 1.756.182.314.16.57.414.73.728.18.356.18.823.18 1.754v8.006c0 .931 0 1.397-.18 1.753-.16.314-.416.57-.73.729-.356.181-.822.181-1.754.181H5.997c-.931 0-1.398 0-1.754-.181a1.67 1.67 0 0 1-.728-.729c-.182-.356-.182-.823-.182-1.756"
    }, null, -1)
  ]))]))
}
export default { render: render }